export const VIEWS = {
  CREATION_METHOD: 'CREATION_METHOD',
  GOALS: 'GOALS',
  WEBSITE: 'WEBSITE',
  LANGUAGE: 'LANGUAGE',
};
